import { getTierUsagePrice } from '@weft/services';
import type { TierUsageData, TiersPricingConfiguration } from '@weft/types';
import type { Currency } from '@weft/types';
import React from 'react';
import { LightInvoiceProductItem } from './LightInvoiceProductItem';

type LightInvoiceTiersUsageChargesProps = {
  productVariantId: string;
  pricingConfiguration: TiersPricingConfiguration;
  tierUsageMap: Record<string, TierUsageData[]>;
  currency: Currency
};

export const LightInvoiceTiersUsageCharges: React.FC<LightInvoiceTiersUsageChargesProps> = ({ productVariantId, tierUsageMap, pricingConfiguration, currency }) => {
  return (
    <React.Fragment>
      {tierUsageMap[productVariantId]?.filter(tierUsage => tierUsage.periodUnits !== 0)
        .sort((a, b) => a.tierIndex - b.tierIndex)
        .map((tierUsage) => {
          const { tierIndex, periodUnits } = tierUsage;
          const { tiers } = pricingConfiguration;
          const tierPrice = getTierUsagePrice(tierUsage, tiers[tierIndex]?.price ?? 0);

          return (
            <LightInvoiceProductItem 
              key={productVariantId + tierIndex}
              name={`Tier ${tierIndex + 1}`}
              price={tierPrice}
              units={periodUnits}
              currency={currency}
            />
          );
        })}
    </React.Fragment>
  );
};